// src/components/property-rates-date-selector/property-rates-date-selector.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment LodgingPlainMessageFragment on LodgingPlainMessage {\n    value\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  query PropertyRatesDateSelectorQuery($context: ContextInput!, $eid: ID!, $dateRange: DateRangeInput!) {\n    propertyRatesDateSelector(context: $context, dateRange: $dateRange, eid: $eid) {\n      configuration {\n        currentDate {\n          ...DateFragment\n        }\n        beginDate {\n          ...DateFragment\n        }\n        endDate {\n          ...DateFragment\n        }\n      }\n      days {\n        ...DayFragment\n      }\n      disclaimer {\n        ...LodgingPlainMessageFragment\n      }\n      submitButtonLabel\n      analyticsPayloads {\n        eventName\n        payload\n      }\n      validationMessage\n    }\n  }\n\n  fragment DayFragment on PropertyCalendarRate {\n    date {\n      ...DateFragment\n    }\n    displayPrice\n    accessibilityLabel\n    theme\n  }\n\n  fragment DateFragment on Date {\n    day\n    month\n    year\n  }\n\n  ", "\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
import React3, { useCallback, useEffect, useRef, useState } from "react";
import { gql as gql2, useQuery } from "@apollo/client";
import { EGDSDateSelector } from "@egds/react-core/date-selector";
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";
import { useLocalization } from "@shared-ui/localization-context";
// src/utils/date-helper.ts
var DATE_FORMAT = "yyyy-MM-dd";
var convertDateInputToDate = function (dateInput) {
  return new Date(dateInput.year, dateInput.month - 1, dateInput.day);
};
// src/utils/eg-clickstream-constants.ts
var EVENT_VERSION = "1.0.0";
var CALENDAR_EXPERIENCE_CONSTANTS = {
  PAGE_NAME: "Product Details",
  PAGE_NAME_DETAILED: "Product Details Lodging Dated",
  PAGE_PRODUCT_LINE: "Lodging"
};
// src/utils/eg-clickstream-helper.ts
var clickstreamEventBuilder = function (param, param1) {
  var event_type = param.EVENT_TYPE,
    event_name = param.EVENT_NAME,
    event_version = param.EVENT_VERSION,
    event_category = param.EVENT_CATEGORY,
    page_name = param1.PAGE_NAME,
    page_name_detailed = param1.PAGE_NAME_DETAILED,
    page_product_line = param1.PAGE_PRODUCT_LINE;
  return {
    event: {
      event_type: event_type,
      event_name: event_name,
      event_version: event_version,
      event_category: event_category
    },
    experience: {
      page_name: page_name,
      page_name_detailed: page_name_detailed,
      page_product_line: page_product_line
    }
  };
};
var clickstreamEventConstantBuilder = function (eventName, eventType) {
  return {
    EVENT_NAME: eventName,
    EVENT_TYPE: eventType,
    EVENT_VERSION: EVENT_VERSION,
    EVENT_CATEGORY: "calendar"
  };
};
var getCalendarOpenedEvent = function () {
  return clickstreamEventBuilder(clickstreamEventConstantBuilder("calendar.opened" /* CALENDAR_OPENED */, "Interaction" /* INTERACTION */), CALENDAR_EXPERIENCE_CONSTANTS);
};
var getCalendarInitiatedEvent = function () {
  return clickstreamEventBuilder(clickstreamEventConstantBuilder("calendar.initiated" /* CALENDAR_INITIATED */, "Impression" /* IMPRESSION */), CALENDAR_EXPERIENCE_CONSTANTS);
};
var getCalendarFailedEvent = function () {
  return clickstreamEventBuilder(clickstreamEventConstantBuilder("calendar.failed" /* CALENDAR_FAILED */, "Impression" /* IMPRESSION */), CALENDAR_EXPERIENCE_CONSTANTS);
};
// src/components/__private/__fragments/lodging-plain-message.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "@egds/react-core/layout-flex";
import { UitkSpacing } from "@egds/react-core/spacing";
import { UitkText } from "@egds/react-core/text";
import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
var fragment = gql(_templateObject());
var LodgingPlainMessage = function (param) {
  var data = param.data;
  return (data === null || data === void 0 ? void 0 : data.value) ? /* @__PURE__ */React.createElement(UitkLayoutFlex, {
    justifyContent: "center"
  }, /* @__PURE__ */React.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React.createElement(Viewport, null, /* @__PURE__ */React.createElement(ViewSmall, null, /* @__PURE__ */React.createElement(UitkSpacing, {
    padding: {
      inlinestart: "three",
      blockend: "three"
    }
  }, /* @__PURE__ */React.createElement(UitkText, {
    size: 200,
    weight: "regular"
  }, data === null || data === void 0 ? void 0 : data.value))), /* @__PURE__ */React.createElement(ViewLarge, null, /* @__PURE__ */React.createElement(UitkSpacing, {
    padding: {
      inlinestart: "three",
      blockend: "four"
    }
  }, /* @__PURE__ */React.createElement(UitkText, {
    size: 200,
    weight: "regular"
  }, data === null || data === void 0 ? void 0 : data.value)))))) : null;
};
LodgingPlainMessage.displayName = "LodgingPlainMessage";
LodgingPlainMessage.fragment = fragment;
// src/components/__private/property-rates-date-selector-day-template/property-rates-date-selector-day-template.tsx
import React2 from "react";
import { UitkDateNumber } from "@egds/react-core/calendar";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { UitkSpacing as UitkSpacing2 } from "@egds/react-core/spacing";
import { EGDSText } from "@egds/react-core/text";
import { CalendarRatesBackground } from "@egds/react-lodging";
var canBeSelected = function (dayData, day) {
  return !(day === null || day === void 0 ? void 0 : day.isPast);
};
var getAriaLabel = function (dayData, day, l10n) {
  var isPast = day.isPast,
    localeDateString = day.localeDateString;
  if (isPast) {
    return l10n.formatText("calendar.unavailable.a11yLabel", localeDateString);
  }
  return localeDateString;
};
var PropertyRatesDateSelectorDayTemplate = function (props) {
  var day = props.day,
    dayData = props.dayData;
  var dateDay = day.day,
    isPast = day.isPast,
    isToday = day.isToday;
  var _ref = dayData || {},
    dateText = _ref.dateText,
    isSelected = _ref.isSelected,
    isWithinDateRange = _ref.isWithinDateRange;
  var _ref1 = dateText || {},
    textValue = _ref1.textValue,
    textWeight = _ref1.textWeight,
    textTheme = _ref1.textTheme;
  var calendarShowTextValue = Boolean(textValue);
  var theme = React2.useMemo(function () {
    if (!isSelected) {
      if (isToday) {
        return "today";
      }
      if (isPast) {
        return "muted";
      }
    }
    return "default";
  }, [isSelected, isToday, isPast]);
  return /* @__PURE__ */React2.createElement(CalendarRatesBackground, {
    theme: !isSelected && !isWithinDateRange && textTheme || "default",
    backgroundShape: "rounded"
  }, /* @__PURE__ */React2.createElement(UitkSpacing2, {
    padding: {
      block: "three"
    }
  }, /* @__PURE__ */React2.createElement(UitkLayoutFlex2, {
    blockSize: "full_size",
    alignItems: "center",
    direction: "column",
    justifyContent: "center",
    className: "uitk-default-day-template"
  }, /* @__PURE__ */React2.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */React2.createElement(UitkDateNumber, {
    theme: theme,
    size: 300,
    weight: "regular",
    disabled: !isToday && !!isPast
  }, dateDay)), /* @__PURE__ */React2.createElement(UitkLayoutFlexItem2, null, calendarShowTextValue && /* @__PURE__ */React2.createElement(EGDSText, {
    theme: !isSelected && textTheme || "default",
    weight: textWeight,
    size: 100
  }, textValue)))));
};
PropertyRatesDateSelectorDayTemplate.canClick = canBeSelected;
PropertyRatesDateSelectorDayTemplate.canSpan = canBeSelected;
PropertyRatesDateSelectorDayTemplate.getAriaLabel = getAriaLabel;
// src/components/property-rates-date-selector/property-rates-date-selector.tsx
var __Query = gql2(_templateObject1(), LodgingPlainMessage.fragment);
var PropertyRatesDateSelector = function (props) {
  var _inputs_dateRange, _inputs_dateRange1, _inputs_dateRange2, _inputs_dateRange3, _data_propertyRatesDateSelector, _data_propertyRatesDateSelector1;
  var inputs = props.inputs,
    onSubmit = props.onSubmit,
    startDateRef = props.startDateRef,
    endDateRef = props.endDateRef,
    _props_isNestDialog = props.isNestDialog,
    isNestDialog = _props_isNestDialog === void 0 ? false : _props_isNestDialog,
    showCalendar = props.showCalendar,
    toggleCalendar = props.toggleCalendar,
    showOnlyLowRates = props.showOnlyLowRates,
    hideDefaultDate = props.hideDefaultDate,
    handleShape = props.handleShape,
    _props_inputLabel1 = props.inputLabel1,
    inputLabel1 = _props_inputLabel1 === void 0 ? "Check-in" : _props_inputLabel1,
    _props_inputLabel2 = props.inputLabel2,
    inputLabel2 = _props_inputLabel2 === void 0 ? "Check-out" : _props_inputLabel2;
  var allowToControlOpenStateFromOutside = typeof showCalendar === "boolean" && toggleCalendar;
  var _React3_useState = _sliced_to_array(React3.useState(allowToControlOpenStateFromOutside ? showCalendar : false), 2),
    initialOpenState = _React3_useState[0],
    setInitialOpenState = _React3_useState[1];
  var _React3_useState1 = _sliced_to_array(React3.useState(initialOpenState), 2),
    isCalendarOpen = _React3_useState1[0],
    setIsCalendarOpen = _React3_useState1[1];
  var track = useEgClickstream();
  var context = inputs.context;
  var formatDateString = useLocalization().formatDateString;
  var hasSubmittedByButton = useRef(false);
  var _useState = _sliced_to_array(useState(((_inputs_dateRange = inputs.dateRange) === null || _inputs_dateRange === void 0 ? void 0 : _inputs_dateRange.start) && !hideDefaultDate ? formatDateString(convertDateInputToDate((_inputs_dateRange1 = inputs.dateRange) === null || _inputs_dateRange1 === void 0 ? void 0 : _inputs_dateRange1.start), {
      raw: DATE_FORMAT
    }) : null), 2),
    checkInDateString = _useState[0],
    setCheckinDateString = _useState[1];
  var _useState1 = _sliced_to_array(useState(((_inputs_dateRange2 = inputs.dateRange) === null || _inputs_dateRange2 === void 0 ? void 0 : _inputs_dateRange2.end) && !hideDefaultDate ? formatDateString(convertDateInputToDate((_inputs_dateRange3 = inputs.dateRange) === null || _inputs_dateRange3 === void 0 ? void 0 : _inputs_dateRange3.end), {
      raw: DATE_FORMAT
    }) : null), 2),
    checkOutDateString = _useState1[0],
    setCheckoutDateString = _useState1[1];
  var _useState2 = _sliced_to_array(useState(void 0), 2),
    invalidEndInput = _useState2[0],
    setInvalidEndInput = _useState2[1];
  var _useState3 = _sliced_to_array(useState({
      defaults: {
        dateText: {
          textWeight: "regular",
          textTheme: null,
          textValue: null
        }
      }
    }), 2),
    dayData = _useState3[0],
    setDayData = _useState3[1];
  var maxDate = React3.useMemo(function () {
    var actualDate = /* @__PURE__ */new Date();
    actualDate.setFullYear(actualDate.getFullYear() + 1, actualDate.getMonth() + 6);
    return actualDate;
  }, []);
  var checkInDateRef = useRef(checkInDateString);
  var checkOutDateRef = useRef(checkOutDateString);
  useEffect(function () {
    var currentDate = /* @__PURE__ */new Date();
    currentDate.setHours(0, 0, 0, 0);
    if (inputs.dateRange.start && convertDateInputToDate(inputs.dateRange.start) < currentDate) {
      setCheckinDateString(null);
      setCheckoutDateString(null);
    }
  }, [inputs.dateRange]);
  var onDateRangeChange = function (startDate, endDate) {
    var setIsWithinDateRangeProperty = function (dateRangeStartDate, dateRangeEndDate, value) {
      if (dateRangeStartDate && dateRangeEndDate) {
        var formattedStartDate = new Date(dateRangeStartDate);
        var formattedEndDate = new Date(dateRangeEndDate);
        if (formattedStartDate < formattedEndDate) {
          formattedStartDate.setDate(formattedStartDate.getDate() + 1);
          for (var day = formattedStartDate; day <= formattedEndDate; day.setDate(day.getDate() + 1)) {
            var stringDate = formatDateString(day, {
              raw: DATE_FORMAT
            });
            if (newDayData[stringDate]) {
              newDayData[stringDate].isWithinDateRange = value;
            }
          }
        }
      }
    };
    var newDayData = _object_spread({}, dayData);
    if (startDate && newDayData[startDate]) {
      newDayData[startDate].isSelected = true;
    }
    if (checkInDateString && newDayData[checkInDateString] && (!startDate || checkOutDateString !== startDate && checkInDateString !== startDate)) {
      newDayData[checkInDateString].isSelected = false;
    }
    if (endDate && newDayData[endDate]) {
      newDayData[endDate].isSelected = true;
    }
    if (checkOutDateString && newDayData[checkOutDateString] && (!endDate && checkOutDateString !== startDate || endDate && checkOutDateString !== startDate && checkInDateString !== endDate && checkOutDateString !== endDate)) {
      newDayData[checkOutDateString].isSelected = false;
    }
    setIsWithinDateRangeProperty(checkInDateString, checkOutDateString, false);
    setIsWithinDateRangeProperty(startDate, endDate, true);
    setDayData(newDayData);
    setCheckinDateString(startDate);
    setCheckoutDateString(endDate);
  };
  var onDateRangeSubmit = function (startDate, endDate) {
    hasSubmittedByButton.current = true;
    var isDatesChanged = checkInDateRef.current !== checkInDateString || checkOutDateRef.current !== checkOutDateString;
    checkInDateRef.current = startDate;
    checkOutDateRef.current = endDate;
    if (isDatesChanged) {
      trackEvent("calendar_new_dates.closed" /* CALENDAR_NEW_DATES_CLOSED */, "calendar_new_dates.selected" /* CALENDAR_NEW_DATES_SELECTED */);
    }
    if (validateMaxDateRange(startDate, endDate)) {
      setInvalidEndInput(void 0);
      if (startDate && endDate) {
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(new Date(startDate.replace(/-/g, "/")), new Date(endDate.replace(/-/g, "/")));
      }
    } else {
      var _data_propertyRatesDateSelector;
      setInvalidEndInput(data === null || data === void 0 ? void 0 : (_data_propertyRatesDateSelector = data.propertyRatesDateSelector) === null || _data_propertyRatesDateSelector === void 0 ? void 0 : _data_propertyRatesDateSelector.validationMessage);
    }
  };
  var onClose = function () {
    var isDatesChanged = checkInDateRef.current !== checkInDateString || checkOutDateRef.current !== checkOutDateString;
    if (isDatesChanged && checkInDateString && checkOutDateString && !hasSubmittedByButton.current && !isNestDialog) {
      onDateRangeSubmit(checkInDateString, checkOutDateString);
    }
    if (allowToControlOpenStateFromOutside) {
      toggleCalendar(false);
    }
    setIsCalendarOpen(false);
    trackEvent("calendar.closed" /* CALENDAR_CLOSED */);
    hasSubmittedByButton.current = false;
  };
  var onOpen = function () {
    track(getCalendarOpenedEvent());
    if (data === null || data === void 0 ? void 0 : data.propertyRatesDateSelector) {
      var _data_propertyRatesDateSelector;
      trackEvent("calendar.presented" /* CALENDAR_PRESENTED */);
      if ((data === null || data === void 0 ? void 0 : (_data_propertyRatesDateSelector = data.propertyRatesDateSelector) === null || _data_propertyRatesDateSelector === void 0 ? void 0 : _data_propertyRatesDateSelector.days.length) > 0) {
        trackEvent("calendar_rates.presented" /* CALENDAR_RATES_PRESENTED */);
      }
    } else {
      track(getCalendarFailedEvent());
    }
  };
  var onNextClicked = function () {
    trackEvent("calendar_next_month.selected" /* CALENDAR_NEXT_MONTH_SELECTED */);
  };
  var onPrevClicked = function () {
    trackEvent("calendar_previous_month.selected" /* CALENDAR_PREVIOUS_MONTH_SELECTED */);
  };
  var trackEvent = function (eventName, newEventName) {
    var _data_propertyRatesDateSelector_analyticsPayloads_find;
    var unpackedAnalyticsPayload = JSON.parse(data === null || data === void 0 ? void 0 : (_data_propertyRatesDateSelector_analyticsPayloads_find = data.propertyRatesDateSelector.analyticsPayloads.find(function (element) {
      return element.eventName === eventName;
    })) === null || _data_propertyRatesDateSelector_analyticsPayloads_find === void 0 ? void 0 : _data_propertyRatesDateSelector_analyticsPayloads_find.payload);
    if (newEventName) {
      var eventDataNewName = unpackedAnalyticsPayload.events[eventName].v1.event_data;
      eventDataNewName.event.event_name = newEventName;
      track(eventDataNewName);
    } else {
      track(unpackedAnalyticsPayload.events[eventName].v1.event_data);
    }
  };
  var variables = _object_spread({}, inputs);
  var _useQuery = useQuery(__Query, {
      variables: variables
    }),
    data = _useQuery.data,
    loading = _useQuery.loading;
  var prependedNumber = useCallback(function (number) {
    return String(number).padStart(2, "0");
  }, [data]);
  var getDateString = useCallback(function (dateObj) {
    return "".concat(dateObj.year, "-").concat(prependedNumber(dateObj.month), "-").concat(prependedNumber(dateObj.day));
  }, [data]);
  var validateMaxDateRange = useCallback(function (startDate, endDate) {
    var maxEndDate = new Date(startDate);
    var endDateFormatted = new Date(endDate);
    maxEndDate.setDate(maxEndDate.getDate() + 28);
    return endDateFormatted <= maxEndDate;
  }, []);
  var createDateDayData = useCallback(function (day) {
    var theme = "default";
    if (day.theme === "HIGHLIGHT" /* HIGHLIGHT */) {
      theme = "positive";
    } else if (day.theme === "AGGRESSIVE" /* AGGRESSIVE */ && !showOnlyLowRates) {
      theme = "negative";
    }
    var dateDayData = {
      dateText: {
        textWeight: theme !== "default" ? "bold" : "regular",
        textTheme: theme,
        textValue: day.displayPrice
      }
    };
    return dateDayData;
  }, [data]);
  var getRatesDayData = useCallback(function (days) {
    var datesDayData = {};
    days.forEach(function (day) {
      var dayString = getDateString(day.date);
      datesDayData[dayString] = createDateDayData(day);
      if (dayString === checkInDateString) {
        datesDayData[dayString].isSelected = true;
      }
      if (dayString === checkOutDateString) {
        datesDayData[dayString].isSelected = true;
      }
    });
    return datesDayData;
  }, [data]);
  var createDayData = useCallback(function (response) {
    var newDayData = {
      defaults: {
        dateText: {
          textWeight: "regular",
          textTheme: null,
          textValue: null
        }
      }
    };
    if (response) {
      var propertyRatesDateSelector = response.propertyRatesDateSelector;
      var days = propertyRatesDateSelector.days;
      newDayData = _object_spread({}, newDayData, getRatesDayData(days));
    }
    return newDayData;
  }, [data]);
  var locale = context.locale.replace("_", "-");
  useEffect(function () {
    if (data) {
      setDayData(createDayData(data));
    }
  }, [data]);
  useEffect(function () {
    if (loading) {
      track(getCalendarInitiatedEvent());
    }
  }, [loading]);
  useEffect(function () {
    if (allowToControlOpenStateFromOutside) {
      if (showCalendar && !isCalendarOpen) {
        var _startDateRef_current;
        startDateRef === null || startDateRef === void 0 ? void 0 : (_startDateRef_current = startDateRef.current) === null || _startDateRef_current === void 0 ? void 0 : _startDateRef_current.click();
      } else if (!showCalendar && isCalendarOpen) {
        document.body.click();
      }
    }
  }, [showCalendar, toggleCalendar]);
  return /* @__PURE__ */React3.createElement(EGDSDateSelector, {
    allowClearDates: false,
    dateFormatOptions: {
      month: "short",
      day: "numeric"
    },
    dayData: dayData,
    dayTemplateComponent: PropertyRatesDateSelectorDayTemplate,
    endDate: checkOutDateString,
    endDateRef: endDateRef,
    maxDate: maxDate,
    startDate: checkInDateString,
    startDateRef: startDateRef,
    initialOpenState: initialOpenState,
    inputName1: "startDate",
    inputName2: "endDate",
    inputLabel1: inputLabel1,
    inputLabel2: inputLabel2,
    invalidInput2: invalidEndInput,
    submitButtonLabel: (data === null || data === void 0 ? void 0 : (_data_propertyRatesDateSelector = data.propertyRatesDateSelector) === null || _data_propertyRatesDateSelector === void 0 ? void 0 : _data_propertyRatesDateSelector.submitButtonLabel) || "Submit",
    onClose: onClose,
    onDateRangeChange: onDateRangeChange,
    onNextClicked: onNextClicked,
    onOpen: onOpen,
    onPrevClicked: onPrevClicked,
    onSubmit: onDateRangeSubmit,
    locale: locale,
    handleShape: handleShape !== null && handleShape !== void 0 ? handleShape : "circle",
    navType: "inset",
    isNestDialog: isNestDialog,
    alertTemplateComponent: LodgingPlainMessage,
    alertTemplateData: {
      data: data === null || data === void 0 ? void 0 : (_data_propertyRatesDateSelector1 = data.propertyRatesDateSelector) === null || _data_propertyRatesDateSelector1 === void 0 ? void 0 : _data_propertyRatesDateSelector1.disclaimer
    }
  });
};
PropertyRatesDateSelector.displayName = "sharedui-PropertyRatesDateSelector";
export { PropertyRatesDateSelector };